import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProgressIndicator = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 18,
			cy: 18,
			r: 17,
			fill: "url(#paint0_linear_359_1287)",
			fillOpacity: .7,
			stroke: "#E6E939",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 18.3124,
			cy: 18.307,
			r: 11.6757,
			fill: "#E6E939"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_359_1287",
			x1: 18.4615,
			y1: 7.84615,
			x2: 16.1538,
			y2: 36,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .9999,
				stopColor: "#F5F85C",
				stopOpacity: .5
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#357DED",
				stopOpacity: 0
			})]
		}) })
	]
});
export default SvgProgressIndicator;
